import { EllipsisOutlined } from '@ant-design/icons';
import { Dropdown } from 'antd';
import PropTypes from 'prop-types';
import React from 'react';

export const PanelMenu = ({ onRemove }) => (
  <Dropdown
    onClick={(e) => e.stopPropagation()}
    menu={{ items: [{ key: '0', label: 'Remove', onClick: onRemove }] }}
    trigger={['click']}
  >
    <EllipsisOutlined rotate={90} />
  </Dropdown>
);

PanelMenu.propTypes = {
  onRemove: PropTypes.func,
};
